import GlobalButton from '../../../ui/GlobalButton';
import CustomModalOverlay from '../../Custom/CustomModalOverlay/CustomModalOverlay';

interface DeleteReferenceLinkModalProps {
  open: any;
  close: any;
  link: any;
  onDeleteLink: any;
}

export default function DeleteReferenceLinkModal({
  open,
  close,
  link,
  onDeleteLink,
}: DeleteReferenceLinkModalProps) {
  const handleDelete = () => {
    onDeleteLink(link);
    close();
  };

  return (
    <CustomModalOverlay
      open={open}
      onClose={close}
      title={'Delete Link'}
      subTitle={'Are you sure you want to delete this link?'}
      width="600px"
    >
      <div className="flex flex-col gap-4 -mt-4">
        <p className="text-sm">
          <span className="text-blue-3 underline underline-offset-2">
            {link?.task_link_url}
          </span>
        </p>
        <div className="flex justify-end gap-4 mb-4">
          <div>
            <GlobalButton variant="stroke" onClick={close}>
              Cancel
            </GlobalButton>
          </div>
          <div>
            <GlobalButton
              variant="secondaryRed"
              state={'default'}
              onClick={handleDelete}
              type={'button'}
            >
              {'Delete'}
            </GlobalButton>
          </div>
        </div>
      </div>
    </CustomModalOverlay>
  );
}
